import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNetflixComponent } from './simple-icons-netflix.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNetflixComponent ],
    exports:      [ SimpleIconsNetflixComponent ],
    bootstrap:    []
})
export class SimpleIconsNetflixModule {}
